var gdConfig = void 0;
var gdErrorHandler = void 0;
var gdLogger = void 0;
var gdAppActions = void 0;
var gdAppSelectors = void 0;
var gdReduxStore = void 0;

export var initializeGaiaData = function initializeGaiaData(_ref) {
  var config = _ref.config,
      errorHandler = _ref.errorHandler,
      logger = _ref.logger,
      appActions = _ref.appActions,
      appSelectors = _ref.appSelectors,
      reduxStore = _ref.reduxStore;

  gdConfig = config;
  gdErrorHandler = errorHandler;
  gdLogger = logger;
  gdAppActions = appActions;
  gdAppSelectors = appSelectors;
  gdReduxStore = reduxStore;
};

export var getConfig = function getConfig() {
  return gdConfig;
};
export var getErrorHandler = function getErrorHandler() {
  return gdErrorHandler;
};
export var getLogger = function getLogger() {
  return gdLogger;
};
export var getAppActions = function getAppActions() {
  return gdAppActions;
};
export var getAppSelectors = function getAppSelectors() {
  return gdAppSelectors;
};
export var getReduxStore = function getReduxStore() {
  return gdReduxStore;
};